import * as React from "react";
import { styled, SxProps } from "@mui/material";

export type CoverProps = {
  sx?: SxProps;
  className?: string;
  img: React.ImgHTMLAttributes<HTMLImageElement>;
  objectPosition?: string;
};

const Cover: React.FC<CoverProps> = (props) => {
  const { img, objectPosition = "center", ...otherProps } = props;

  return (
    <StyledFigure objectPosition={objectPosition} {...otherProps}>
      {img.src && <img {...img} alt={img.alt || ""} loading="lazy" />}
    </StyledFigure>
  );
};

export default Cover;

const StyledFigure = styled("figure", { shouldForwardProp: (prop) => prop !== "objectPosition" })<{
  objectPosition: string;
}>(({ objectPosition }) => ({
  position: "absolute",
  left: 0,
  top: 0,
  right: 0,
  bottom: 0,
  zIndex: 0,
  pointerEvents: "none",
  img: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    objectPosition: objectPosition,
  },
}));
